var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#chromeclip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.34 18.39v30.684h17.907l15.729-27.247h35.62C68.966 8.857 55.51 0 39.976 0 25.844 0 13.454 7.308 6.34 18.39z",
    fill: "#DB4437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.34 18.39v30.684h17.907l15.729-27.247h35.62C68.966 8.857 55.51 0 39.976 0 25.844 0 13.454 7.308 6.34 18.39z",
    fill: "url(#chromepaint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.34 18.39l17.955 30.733.387-.242L6.63 17.907c-.096.193-.193.339-.29.484z",
    fill: "#3E2723",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.088 79.903l17.617-17.616V49.074H24.247L6.34 18.391C2.323 24.586 0 32.039 0 39.976c0 21.44 16.89 38.96 38.088 39.927z",
    fill: "#0F9D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.088 79.903l17.617-17.616V49.074H24.247L6.34 18.391C2.323 24.586 0 32.039 0 39.976c0 21.44 16.89 38.96 38.088 39.927z",
    fill: "url(#chromepaint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.604 79.903c.146 0 .34 0 .484.049l17.278-30.248-.387-.242-17.375 30.441z",
    fill: "#263238",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.088 79.903l17.617-17.616V49.074l-17.617 30.83z",
    fill: "#FFCD40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.088 79.903l17.617-17.616V49.074l-17.617 30.83z",
    fill: "url(#chromepaint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.976 21.827l15.729 27.247-17.617 30.83c.63.048 1.259.048 1.888.048 22.069 0 39.976-17.907 39.976-39.976a40.004 40.004 0 00-4.356-18.149h-35.62z",
    fill: "#FFCD40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.976 21.827l15.729 27.247-17.617 30.83c.63.048 1.259.048 1.888.048 22.069 0 39.976-17.907 39.976-39.976a40.004 40.004 0 00-4.356-18.149h-35.62z",
    fill: "url(#chromepaint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.596 21.827h-35.62v9.486l35.62-9.486z",
    fill: "url(#chromepaint4_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.34 18.39l17.907 30.684 8.13-4.694L6.34 18.39z",
    fill: "url(#chromepaint5_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.705 49.074l-8.082-4.694-9.535 35.523 17.617-30.829z",
    fill: "url(#chromepaint6_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.976 58.125c10.023 0 18.149-8.126 18.149-18.15 0-10.023-8.126-18.148-18.15-18.148-10.023 0-18.148 8.125-18.148 18.149 0 10.023 8.125 18.149 18.149 18.149z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.976 54.495c8.019 0 14.519-6.5 14.519-14.52 0-8.018-6.5-14.518-14.52-14.518-8.018 0-14.518 6.5-14.518 14.519s6.5 14.519 14.519 14.519z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.354 21.343H39.976c-10.018 0-18.149 8.13-18.149 18.149v.435c0-10.018 8.13-18.148 18.149-18.148H75.547c-.048-.146-.096-.29-.193-.436z",
    fill: "#3E2723",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.266 58.125h-.29c-6.727 0-12.583-3.678-15.73-9.099L6.34 18.391c-.048.048-.097.145-.145.193L24.247 49.51c3.146 5.42 9.002 9.099 15.729 9.099 5.033 0 9.63-2.081 12.922-5.42a18.162 18.162 0 01-12.438 4.936c-.097.048-.145 0-.194 0z",
    fill: "#fff",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.316 57.011c.097-.048.193-.096.29-.096-.097 0-.193.048-.29.096zM47.235 56.624c.29-.096.533-.242.823-.387-.29.145-.532.29-.823.387zM45.445 57.302c.048 0 .096-.049.145-.049-.049 0-.097.049-.145.049zM55.705 49.074zM48.397 56.092c.242-.097.435-.242.677-.387-.242.145-.484.242-.677.387z",
    fill: "#fff",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M58.076 41.428v-.29c.049.048.049.145 0 .29zM52.898 53.188l1.161-1.161.194-.34a19.902 19.902 0 01-1.355 1.501z",
    fill: "#3E2723"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M57.64 35.62a18.78 18.78 0 01.678 4.985c0 2.759-.629 5.324-1.742 7.695 1.258-2.468 2.033-5.324 2.033-8.324 0-10.018-8.131-18.149-18.15-18.149h-.241c8.42.097 15.487 5.953 17.423 13.793z",
    fill: "#3E2723"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M57.98 42.492c0-.096 0-.145.048-.242-.048.097-.048.194-.048.242zM45.59 57.254c.242-.097.484-.146.677-.242-.193.096-.435.145-.677.242zM46.606 56.915c.194-.097.436-.145.63-.242a3.36 3.36 0 00-.63.242zM49.026 55.705c.097-.049.145-.097.242-.145-.048.048-.145.096-.242.145zM48.058 56.237c.097-.048.194-.097.339-.194-.145.097-.242.146-.339.194zM40.218 58.125h.048a20.313 20.313 0 005.179-.823 16.884 16.884 0 01-5.227.823z",
    fill: "#3E2723"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.705 49.074a18.494 18.494 0 01-6.437 6.534c-.097.048-.145.097-.242.145-.242.145-.436.242-.678.387a2.776 2.776 0 00-.338.194c-.242.145-.533.242-.823.387a3.36 3.36 0 01-.63.242c-.096.048-.193.097-.29.097-.242.097-.435.145-.677.242-.049 0-.097.048-.145.048a16.81 16.81 0 01-5.179.823h.145c4.84 0 9.196-1.888 12.438-4.937.484-.483.92-1.016 1.356-1.548l1.5-2.614z",
    fill: "#fff",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M55.705 49.074a18.494 18.494 0 01-6.437 6.534c-.097.048-.145.097-.242.145-.242.145-.436.242-.678.387a2.776 2.776 0 00-.338.194c-.242.145-.533.242-.823.387a3.36 3.36 0 01-.63.242c-.096.048-.193.097-.29.097-.242.097-.435.145-.677.242-.049 0-.097.048-.145.048a16.81 16.81 0 01-5.179.823h.145c4.84 0 9.196-1.888 12.438-4.937.484-.483.92-1.016 1.356-1.548l1.5-2.614z",
    fill: "#3E2723"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.64 35.62c-.048-.194-.096-.339-.145-.532.34 1.161.533 2.323.63 3.581v.097c.048.387.048.823.048 1.21s0 .726-.048 1.113v.29c0 .29-.049.581-.097.872 0 .096 0 .145-.048.242a17.808 17.808 0 01-2.275 6.533l-1.5 2.613-.194.34-15.923 27.876h.533l17.277-30.248c.242-.436.484-.92.726-1.404a17.775 17.775 0 001.743-7.695 20.94 20.94 0 00-.726-4.888z",
    fill: "#fff",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.976.436c22.02 0 39.83 17.761 39.976 39.733v-.242C79.952 17.907 62.045 0 39.976 0 17.906 0 0 17.907 0 39.976v.242C.145 18.246 17.955.436 39.976.436z",
    fill: "#fff",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.976 79.516c22.02 0 39.83-17.762 39.976-39.734v.242C79.952 62.094 62.045 80 39.976 80 17.906 80 0 62.045 0 39.976v-.242c.145 21.972 17.955 39.782 39.976 39.782z",
    fill: "#3E2723",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.976 79.952c22.078 0 39.976-17.898 39.976-39.976S62.054 0 39.976 0 0 17.898 0 39.976s17.898 39.976 39.976 39.976z",
    fill: "url(#chromepaint7_radial)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "chromepaint0_linear",
    x1: 12.0391,
    y1: 34.4641,
    x2: 35.8912,
    y2: 20.5314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A52714",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A52714",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chromepaint1_linear",
    x1: 48.8936,
    y1: 67.4193,
    x2: 22.3919,
    y2: 51.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#055524",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#055524",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chromepaint2_linear",
    x1: 37.2686,
    y1: 22.295,
    x2: 43.9427,
    y2: 51.5199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA6100",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EA6100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chromepaint3_linear",
    x1: 50.2641,
    y1: 19.3273,
    x2: 56.9381,
    y2: 48.5522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA6100",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EA6100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "chromepaint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.245 21.784) scale(38.1987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2723",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E2723",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "chromepaint5_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.306 18.41) scale(35.4573)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2723",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E2723",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "chromepaint6_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.908 40.043) scale(39.9215)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "chromepaint7_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.942 10.91) scale(80.3019)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "chromeclip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H79.9516V80H0z"
  })))));
};

export default __webpack_public_path__ + "static/media/chrome.383810af.svg";
export { SvgComponent as ReactComponent };